import { isWithinTrackGap } from "../../constants";
import type { TTimelineItem } from "../../types";
import type { BoxAnchor, TrackingInterval } from "../contracts";

/** Track identity comes from the model; unrelated detections are never associated by label. */
export function buildTrackingIntervals(items: readonly TTimelineItem[]): TrackingInterval[] {
  const intervals: TrackingInterval[] = [];
  const visit = (item: TTimelineItem) => {
    if (item.type === "collection") item.children.forEach(visit);
    if (item.type !== "track") return;
    const anchors: BoxAnchor[] = [...item.waypoints]
      .sort((a, b) => a.time - b.time)
      .map((waypoint, index) => ({ waypoint, index }))
      .filter(({ waypoint }) => waypoint.kind === "point_box")
      .map(({ waypoint, index }) => ({
        id: `${item.id}::wp::${index}`,
        time: waypoint.time,
        coordinates: (waypoint as Extract<typeof waypoint, { kind: "point_box" }>).coordinates,
      }));
    for (let i = 0; i < anchors.length - 1; i++) {
      const start = anchors[i]!;
      const end = anchors[i + 1]!;
      if (!Number.isFinite(start.time) || !Number.isFinite(end.time) || start.time < 0 || end.time <= start.time)
        continue;
      // Neighboring GT boxes may cross a clock-second boundary, but a longer
      // gap is insufficient evidence that the object remained in frame.
      if (!isWithinTrackGap(start.time, end.time)) continue;
      intervals.push({
        id: JSON.stringify([item.id, start, end]),
        trackId: item.id,
        start,
        end,
      });
    }
  };
  items.forEach(visit);
  return intervals;
}
